import React from "react";

import propTypes from "prop-types";

import CurrencyAmount from "./CurrencyAmount";

const Discount = ({ value }) => {
  return (
    <CurrencyAmount
      value={value}
      iconSize="0.7em"
      sx={{
        color: "text.secondary",
        fontSize: "1.15rem",
        fontWeight: 500,
        opacity: 0.78,
        textDecoration: "line-through",
      }}
    />
  );
};

Discount.propTypes = {
  value: propTypes.number.isRequired,
};

export default Discount;
